import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Config } from '../../../../shared/types';
import { useAdminConfigs } from '../../../hooks/useAdminConfigs';
import { ConfigForm } from './ConfigForm';

export const ConfigEdit = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedConfig, setSelectedConfig] = useState<Config>();
    const { data: configs = [], isFetched } = useAdminConfigs();

    useEffect(() => {
        if (!isFetched) return;

        const config = configs.find((config) => config._id.toString() === id!);

        if (config) setSelectedConfig(config);
    }, [id, isFetched]);

    if (!selectedConfig) return null;

    return <ConfigForm config={selectedConfig} />;
};
